import Vue from 'vue'
import storage from 'src/unit/storage'
import VueRouter from 'vue-router'
import store from 'store'
import { checkAcls } from 'common/acl'

// import modules
import demo from './modules/demo'
import user from './modules/user'
// 维保项目模块
import emsUserCenter from './modules/ems/userCenter'
import emsHome from './modules/ems/home'
import emsProject from './modules/ems/project'
import emsPlan from './modules/ems/plan'
import emsContract from './modules/ems/contract'
import emsDevice from './modules/ems/device'
import emsDevicecheck from './modules/ems/deviceCheck'
import emsReport from './modules/ems/report'
import emsCustomer from './modules/ems/customer'
// import emsRepair from './modules/ems/repair'
import emsMend from './modules/ems/mend'
import emsExamine from './modules/ems/examine'
import emsServerOrder from './modules/ems/serverOrder'
import emsProjectAuthorization from './modules/ems/projectAuthorization'
import emsTeam from './modules/ems/team'        // 团队模块

// 甲方物业端模块
import partyAHome from './modules/partyA/home'
import partyAUser from './modules/partyA/user'


Vue.use(VueRouter)
let $vux = Vue.$vux

let routes = []
const router = new VueRouter({
    routes: routes
        .concat(demo)
        .concat(user)
        .concat(emsUserCenter)
        .concat(emsHome)
        .concat(emsCustomer)
        // .concat(emsRepair)
        .concat(emsMend)
        .concat(emsContract)
        .concat(emsExamine)
        .concat(emsPlan)
        .concat(emsProjectAuthorization)
        .concat(emsTeam)
        .concat(emsReport)
        .concat(emsDevice)
        .concat(emsProject)
        .concat(emsServerOrder)
        .concat(emsDevicecheck)
        .concat(partyAHome)
        .concat(partyAUser)
})

router.beforeEach((to, from, next) => {
    let self = this
    // 友盟统计
    if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
    }
    // 百度统计
    let _hmt = window._hmt || []
    if (to.path) {
        _hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
    let token = store.state.user.token
    let userType =  localStorage.getItem('user_source')
    if (to.path === '/login' || to.path === '/partyALogin') {
        if (token) {
            // 从url获取的token替代本地token，并删除本地信息后跳转到登录url
            if (to.query.token && to.query.token !== token) {
                if (userType === 'party_a') {
                    store.dispatch('/partyAMy', false, { query: { token: to.query.token } })
                } else {
                    store.dispatch('user/logout', false, { query: { token: to.query.token } })
                }
                // store.dispatch('user/logout', false, { query: { token: to.query.token } })
            } else if (to.query.isAdmin) { // pc端admin登录
                store.state.user.token = ''
                next()
            } else {
                if (userType === 'party_a') {
                    next('/partyA/partyAHome')
                } else {
                    next('/ems/home')    // 加时间戳：部分机型微信有缓存不刷新页面
                }
                // next('/ems/home')
            }
        } else {
            next()
        }
    } else if (to.name === 'register' || to.name === 'syncAccount' || to.name === 'appDownload' || to.path === '/ems/onlineReport/reportMsg') {
        // 从url获取的token替代本地token，并删除本地信息后跳转到登录url
        if (to.query.token && to.query.token !== token) {
            store.dispatch('user/logout', { query: { token: to.query.token } })
        } else {
            next()
        }
    } else {
        if (token) {
            // 从url获取的token替代本地token，并删除本地信息后跳转到登录url
            if (to.query.token && to.query.token !== token) {
                store.dispatch('user/logout', { query: { token: to.query.token } })
            } else {
                next()
            }
        } else {
            next()
        }
    }
    let $loading = document.querySelector('#appPageLoading')
    if ($loading) $loading.remove()
})


router.afterEach((to, from) => {
    store.dispatch('common/setPageTitle', to.meta.title)
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js